import {gsap} from "gsap";
import {ScrollToPlugin, ScrollTrigger} from "gsap/all";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

class StickyScrollAnimation {
	static instance = null;

	static create(options) {
		if (!StickyScrollAnimation.instance) {
			StickyScrollAnimation.instance = new StickyScrollAnimation(options);
		}
		return StickyScrollAnimation.instance;
	}

	static destroy() {
		if (StickyScrollAnimation.instance) {
			this.instance.beforeDestroy();
			StickyScrollAnimation.instance = null;
		}
	}

	get defaultOptions() {
		return {
			selector: null,
			trigger: null,
			initialHeight: 0,
			currentHeight: 0,
		}
	}

	constructor(options) {
		this.options = {...this.defaultOptions, ...options};
		this.options.initialHeight = this.options.trigger.offsetHeight;
		this.options.currentHeight = this.options.trigger.offsetHeight;

		const mm = gsap.matchMedia()

		mm.add('(min-width: 1080px)', () => {
			this.initObserver();
		})

		mm.add('(max-width: 1079px)', () => {
			StickyScrollAnimation.destroy();
		})
	}

	init() {
		this.timeline = ScrollTrigger.create({
			trigger: this.options.trigger,
			start: `top +=${document.querySelector('.header').offsetHeight}}}`,
			end: () => `+=${this.options.currentHeight - this.options.initialHeight}}`,
			pin: true,
			pinSpacing: false,
			markers: false,
		});
	}

	beforeDestroy() {
		//scroll to with gsap
		gsap.to(window, {
			duration: 0.1, scrollTo: ".section-spotlight", onComplete: () => {
				this.timeline.kill();
			}
		});

	}

	initObserver() {
		new ResizeObserver(() => {
			if (this.options.currentHeight < this.options.trigger.offsetHeight) {
				this.options.currentHeight = this.options.trigger.offsetHeight;

				ScrollTrigger.refresh();
				this.init();

			}

		}).observe(this.options.trigger);
	}


}

export {StickyScrollAnimation as default}